"use strict";

import React, { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import { isUserLoggin } from "../_helpers/auth.helper";
import { cookieConstants } from "../_redux/_constants/auth.constants";
import { SuspenseLoading } from "../components/_uiComponents/common/UiLoadingSpinner";

import ErrorBoundry from "../components/common/ErrorBoundry";

import { TopNavBar } from "../components/_uiComponents/common/TopNavBar";
import { Footer } from "../components/_uiComponents/Footer";
import { UiAdminHeader } from "../components/_uiComponents/common/UiAdminHeader";
import Sidebar from "../components/_uiComponents/sidebar/Sidebar";
import {
     ContentRightWr,
     MainLeftTitle,
     CreateButton,
} from "../components/_uiComponents/WrapperComponents";

export const useAuth = () => {
     return isUserLoggin(cookieConstants.IS_LOGGED_IN);
};

export function PrivateRoute() {
      const auth = useAuth();

     return auth ? (
          <>
               <TopNavBar newNotification/>
               <div className="sbt-dashboard-drawer__wr">
                    <UiAdminHeader />
                    <Box sx={{ display: "flex" }}>
                         <Suspense fallback={<SuspenseLoading />}>
                              <ErrorBoundry>
                                   <Sidebar />
                                   <Box
                                        component="main"
                                        sx={{
                                             flexGrow: 1,
                                             pt: 0,
                                             pl: 2,
                                             overflow: "hidden",
                                        }}
                                   >
                                        <ContentRightWr>
                                             <div className="sbt-data-grid__wr">
                                                  
                                                  <Outlet />
                                             </div>
                                        </ContentRightWr>
                                   </Box>
                              </ErrorBoundry>
                         </Suspense>
                    </Box>
               </div>
               <Footer />
          </>
     ) : (
          <Navigate to="/" />
     );
}

export function PublicRoute({ children }) {
     const auth = useAuth();
 
     if (auth) {
         return <Navigate to="/app/dashboard" />;
     }
 
     return children;
 }
